import actions from "actions";
import axios from "axios";
import constants from "constants";
import _ from "lodash";
import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { push } from "redux-router";
import UpcomingWebinarItem from "./UpcomingWebinarItem";
import UpcomingWebinarsView from "./UpcomingWebinars";
import { showAddToCalendarModal } from "../../../../actions/mixed";

const { UPCOMING_WEBINARS } = constants;

const { subscribeWebinarSaga, unsubscribeWebinarSaga } = actions;

class UpcomingWebinarsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptionEvents: {},
      is_subscription_sponsor: this.props.is_subscription_sponsor || false,
    };
  }

  componentWillReceiveProps(props) {
    if (
      !_.isEqual(
        this.props.webinars.is_subscription_sponsor,
        props.webinars.is_subscription_sponsor
      )
    ) {
      this.setState({
        ...this.state,
        is_subscription_sponsor:
          this.props.is_subscription_sponsor || props.is_subscription_sponsor,
      });
    }
    if (!_.isEqual(this.props.subscriptions, props.subscriptions)) {
      this.setState({
        ...this.state,
        subscriptionEvents: {
          ...this.state.subscriptionEvents,
          ...props.subscriptions,
        },
      });
    }
  }

  toggleSponsorsSubscription = (webinar) => {
    this.setState({
      ...this.state,
      is_subscription_sponsor: !this.state.is_subscription_sponsor,
    });
    axios.put("/api/v1/subscription_sponsors/" + webinar.id);
  };

  webinars = () =>
    this.props.webinars.map((webinar) => {
      return (
        <UpcomingWebinarItem
          key={webinar.id}
          webinar={webinar}
          // subscriptions={this.props.subscriptions}
          subscriptions={this.state.subscriptionEvents}
          is_subscription_sponsor={this.state.is_subscription_sponsor}
          toggleSponsorsSubscription={this.toggleSponsorsSubscription}
          userRole={this.props.userRole}
          onSubscriptionChange={(e, sessionIndex) =>
            this.onSubscriptionChange(e, webinar.id, sessionIndex)
          }
          toggleSubscription={() => this.toggleSubscription(webinar)}
          openAddToCalendarModal={() =>
            this.props.openAddToCalendarModal({ webinarId: webinar.id })
          }
        />
      );
    });

  onSubscriptionChange = (roomId, webinarId, sessionIndex) => {
    let roomIdByWebinar = this.state.subscriptionEvents[webinarId];
    const roomIdInt = parseInt(roomId);

    if (roomIdByWebinar && roomIdByWebinar.indexOf(roomIdInt) > -1) {
      return;
    }

    roomIdByWebinar = roomIdByWebinar || [];
    roomIdByWebinar[sessionIndex] = roomIdInt;

    this.setState({
      subscriptionEvents: {
        ...this.state.subscriptionEvents,
        [webinarId]: roomIdByWebinar,
      },
    });
  };

  toggleSubscription = (webinar) => {
    const { dispatch, isLogged } = this.props;

    if (!isLogged) {
      dispatch(push("/users/sign_in"));
      return;
    }

    if (webinar.subscription_id) {
      this.props.unsubscribeWebinar(
        webinar.subscription_id,
        webinar.id,
        webinar.group_id
      );
    } else {
      this.props.subscribeWebinar(webinar);
    }
  };

  render() {
    return (
      <UpcomingWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    );
  }
}

UpcomingWebinarsContainer.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
  unsubscribeWebinar: PropTypes.func,
  pages: PropTypes.integer,
};

const mapStateToProps = (state) => ({
  pages: state.webinars[UPCOMING_WEBINARS].pages,
  subscriptions: state.webinars[UPCOMING_WEBINARS].subscriptions,
  isLogged: !_.isEmpty(state.users.user),
  userRole: state.users.user.user_type,
});

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar, true)),
  unsubscribeWebinar: (id, weinbarId, group_id) =>
    dispatch(unsubscribeWebinarSaga(id, weinbarId, group_id)),
  openAddToCalendarModal: (payload) =>
    dispatch(showAddToCalendarModal(payload)),
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpcomingWebinarsContainer);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserWebinars/Upcoming/UpcomingWebinarsContainer.jsx